import { HeadingPriority } from "atoms/constants/heading-priority";
import Trans from "atoms/i18n/trans";
import Heading from "atoms/typography/heading";
import Paragraph from "atoms/typography/paragraph";
import moment from "moment";
import React from "react";
import DateUtils from "utilities/date-utils";
import { t } from "utilities/localization-utils";
import RecipientAccessShareSpaceRecipientService from "utilities/services/share-space/recipient-access/share-space-recipient-service";

export interface ShareSpaceMessageBlockProps {
    guid: string;
    fullName?: string;
    subject?: string;
    message?: string;
    expiresOn?: Date;
    sentOn?: Date;
    replyToEmailAddress?: string;
}

const BASE_CLASS = "c-share-space-message-block";

const ShareSpaceMessageBlock: React.FC<ShareSpaceMessageBlockProps> = (
    props: ShareSpaceMessageBlockProps
) => {
    const { guid, message, expiresOn, replyToEmailAddress, fullName, sentOn } =
        props;
    const mailToUrl = `mailto:${replyToEmailAddress}?subject=${encodeURIComponent(`${t("re")}: ${t("sharedWithYou")}`)}`;
    const expiration = moment(expiresOn).fromNow();
    const { patch: trackReply } =
        RecipientAccessShareSpaceRecipientService.usePatchTrackReply();

    return (
        <section className={BASE_CLASS}>
            <Heading
                priority={HeadingPriority.Two}
                cssClassName={`${BASE_CLASS}__heading`}>
                {t("sharedWithYou")}
            </Heading>
            <aside className={`${BASE_CLASS}__expiration`}>
                {t("thisLinkWillExpire", { expiration })}
            </aside>
            <div className={`${BASE_CLASS}__body`}>
                <Paragraph cssClassName={`${BASE_CLASS}__byline`}>
                    <Trans i18nKey={"fromNameOnDate"}>
                        From: <strong>{{ name: fullName }}</strong> on{" "}
                        {{
                            date: DateUtils.formatCustomDate(
                                sentOn?.toString(),
                                "M/D/YYYY"
                            ),
                        }}
                    </Trans>
                </Paragraph>
                <Paragraph cssClassName={`${BASE_CLASS}__message`}>
                    {message}
                </Paragraph>
                <footer className={`${BASE_CLASS}__buttonWrapper`}>
                    <a
                        className="c-button"
                        href={mailToUrl}
                        onClick={() => {
                            trackReply({ guid: guid });
                        }}>
                        {t("reply")}
                    </a>
                </footer>
            </div>
        </section>
    );
};

export default ShareSpaceMessageBlock;
